<template>
	<!-- <b-overlay show="true" rounded="sm"> -->
	<div id="app" class="d-flex flex-column min-vh-100 theme6" ref="baseBody">
		<div
			id="loader"
			:class="`position-absolute justify-content-center align-items-center ${loadData === false ? 'd-none' : 'd-flex'} `"
		>
			<div class="">
				<!-- <img src="../../assets/img/U_contract_warna.png" style="width: 200px" /> -->
				<div class="spinner-border" role="status">
					<span class="visually-hidden">Loading...</span>
				</div>
			</div>
		</div>
		<div class="card-body text-center" v-if="printName() == 'Unknown'">
			<div class="spinner-border" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>
		<div v-else>
			<nav class="navbar navbar-vertical fixed-start navbar-expand-md navbar-vibrant navbar-dark" id="sidebar">
				<div class="test"></div>
				<div class="container-fluid">
					<button
						class="navbar-toggler"
						type="button"
						data-toggle="collapse"
						data-target="#sidebarCollapse"
						aria-controls="sidebarCollapse"
						aria-expanded="false"
						aria-label="Toggle navigation"
						v-b-toggle.sidebars
					>
						<span class="navbar-toggler-icon"></span>
					</button>
					<!-- Brand -->
					<router-link tag="a" class="navbar-brand" to="/">
						<img src="../../assets/img/U_contract_warna.png" class="navbar-brand-img mx-auto" alt="..." />
					</router-link>

					<div class="navbar-user d-md-none">
						<!-- Dropdown -->
						<div class="dropdown">
							<!-- Toggle -->
							<a
								href="#"
								id="sidebarIcon"
								class="dropdown-toggle"
								role="button"
								data-bs-toggle="dropdown"
								aria-haspopup="true"
								aria-expanded="false"
							>
								<b-nav-item-dropdown right style="list-style-type: none">
									<!-- Using 'button-content' slot -->
									<template #button-content>
										<div class="avatar avatar-sm avatar-online">
											<span class="avatar-title rounded-circle avatar-online">U</span>
										</div>
									</template>
									<b-dropdown-item href="#">
										{{ profile.fullname }}
										<br />
										{{ profile.roles_uenrol ?? 'User' }}
									</b-dropdown-item>
									<hr />
									<router-link tag="b-dropdown-item" to="/profile">Profile</router-link>
									<b-dropdown-item href="#" @click.prevent="logout"> Logout </b-dropdown-item>
								</b-nav-item-dropdown>
							</a>

							<!-- Menu -->
							<div class="dropdown-menu dropdown-menu-end" aria-labelledby="sidebarIcon">
								<b-link class="dropdown-item" @click="logout">Logout</b-link>
							</div>
						</div>
					</div>

					<!-- Collapse -->
					<div class="collapse navbar-collapse" id="sidebarCollapse">
						<!-- Divider -->
						<!-- <hr class="navbar-divider my-3"> -->

						<!-- Heading -->
						<!-- <h6 class="navbar-heading text-colors text-dark mt-3">
            Health Management System
          </h6> -->

						<!-- Navigation -->
						<ul class="navbar-nav accordion mt-5" style="z-index: 99999999" role="tablist">
							<li class="nav-item" v-for="(item, index) in filteredMenus" :key="`${item.name}${index}`">
								<a
									:class="`nav-link text-colors mx-3 ${item.childs && item.childs?.length > 0 && index > 0 ? 'collapsed' : ''} ${
										item.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'
									}`"
									v-b-toggle="item.link"
									data-navtype="parent"
									v-if="item.childs && item.childs?.length > 0"
								>
									<i :class="`fe fe-${item.icon}`"></i>
									{{ $t(item.i18n) || item.name }}
								</a>
								<router-link
									tag="a"
									@click.native="load1"
									:class="`nav-link text-colors mx-3 ${item.childs && item.childs?.length > 0 && index > 0 ? 'collapsed' : ''} ${
										item.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'
									}`"
									:to="item.childs && item.childs?.length > 0 ? `#${item.link}` : item.link"
									v-else
								>
									<i :class="`fe fe-${item.icon}`"></i>
									{{ $t(item.i18n) || item.name }}
								</router-link>
								<!-- ${(item.child && (item.child?.length > 0) && index == 0) || item.click ? 'show' : ''} -->
								<b-collapse
									:id="item.childs && item.childs?.length > 0 ? item.link : ''"
									v-if="item.childs && item.childs?.length > 0"
									:visible="item.childs && item.childs?.length > 0 && index == 0"
									accordion="my-accordion"
									role="tabpanel"
								>
									<ul class="nav nav-sm flex-column accordion" role="tablist">
										<li class="nav-item" v-for="(a, i) in item.childs" :key="i">
											<a
												:class="`nav-link text-colors mx-3 ${a.childs && a.childs?.length > 0 && index > 0 ? 'collapsed' : ''} ${
													a.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'
												}`"
												v-b-toggle="a.link"
												data-navtype="parent"
												v-if="a.childs && a.childs?.length > 0"
											>
												{{ $t(a.i18n) || a.name }}
											</a>
											<router-link
												tag="a"
												@click.native="load1"
												:class="`nav-link mx-3 ${a.click ? 'fw-bolder' : 'hovers text-white fw-lighter'}`"
												:to="a.link"
												v-else
											>
												{{ $t(a.i18n) || a.name }}
											</router-link>
											<b-collapse
												:id="a.childs && a.childs?.length > 0 ? a.link : ''"
												v-if="a.childs && a.childs?.length > 0"
												:visible="a.childs && a.childs?.length > 0 && index == 0"
												accordion="my-accordion-2"
												role="tabpanel"
											>
												<ul class="nav nav-sm flex-column">
													<li class="nav-item" v-for="(lv3, idx) in a.childs" :key="idx">
														<router-link
															tag="a"
															@click.native="load1"
															:class="`nav-link mx-3 ${lv3.click ? 'fw-bolder' : 'hovers text-white fw-lighter'}`"
															:to="lv3.link"
														>
															{{ $t(lv3.i18n) || lv3.name }}
														</router-link>
													</li>
												</ul>
											</b-collapse>
										</li>
									</ul>
								</b-collapse>
							</li>
						</ul>

						<!-- Divider -->
						<hr class="navbar-divider my-3" />
					</div>
					<!-- / .navbar-collapse -->
				</div>
				<b-collapse id="sidebars" class="w-100 bg-primary hidden">
					<div class="mt-3 mb-5" style="margin-left: 10px">
						<ul class="navbar-nav accordion mt-5" style="z-index: 99999999" role="tablist">
							<li class="nav-item" v-for="(item, index) in filteredMenus" :key="`${item.name}${index}`">
								<a
									:class="`nav-link text-colors mx-3 ${item.childs && item.childs?.length > 0 && index > 0 ? 'collapsed' : ''} ${
										item.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'
									}`"
									v-b-toggle="item.link"
									data-navtype="parent"
									v-if="item.childs && item.childs?.length > 0"
								>
									<i :class="`fe fe-${item.icon}`"></i>
									{{ $t(item.i18n) || item.name }}
								</a>
								<router-link
									tag="a"
									:class="`nav-link text-colors mx-3 ${item.childs && item.childs?.length > 0 && index > 0 ? 'collapsed' : ''} ${
										item.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'
									}`"
									:to="item.childs && item.childs?.length > 0 ? `#${item.link}` : item.link"
									v-else
								>
									<i :class="`fe fe-${item.icon}`"></i>
									{{ $t(item.i18n) || item.name }}
								</router-link>
								<!-- ${(item.childs && (item.childs?.length > 0) && index == 0) || item.click ? 'show' : ''} -->
								<b-collapse
									:id="item.childs && item.childs?.length > 0 ? item.link : ''"
									v-if="item.childs && item.childs?.length > 0"
									:visible="item.childs && item.childs?.length > 0 && index == 0"
									accordion="my-accordion"
									role="tabpanel"
								>
									<ul class="nav nav-sm flex-column accordion" role="tablist">
										<li class="nav-item" v-for="(a, i) in item.childs" :key="i">
											<a
												:class="`nav-link text-colors mx-3 ${a.childs && a.childs?.length > 0 && index > 0 ? 'collapsed' : ''} ${
													a.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'
												}`"
												v-b-toggle="a.link"
												data-navtype="parent"
												v-if="a.childs && a.childs?.length > 0"
											>
												{{ $t(a.i18n) || a.name }}
											</a>
											<router-link
												tag="a"
												:class="`nav-link mx-3 ${a.click ? 'fw-bolder' : 'hovers text-white fw-lighter'}`"
												:to="a.link"
												v-else
											>
												{{ $t(a.i18n) || a.name }}
											</router-link>
											<b-collapse
												:id="a.childs && a.childs?.length > 0 ? a.link : ''"
												v-if="a.childs && a.childs?.length > 0"
												:visible="a.childs && a.childs?.length > 0 && index == 0"
												accordion="my-accordion-2"
												role="tabpanel"
											>
												<ul class="nav nav-sm flex-column">
													<li class="nav-item" v-for="(lv3, idx) in a.childs" :key="idx">
														<router-link
															tag="a"
															:class="`nav-link mx-3 ${lv3.click ? 'fw-bolder' : 'hovers text-white fw-lighter'}`"
															:to="lv3.link"
														>
															{{ $t(lv3.i18n) || lv3.name }}
														</router-link>
													</li>
												</ul>
											</b-collapse>
										</li>
									</ul>
								</b-collapse>
							</li>
						</ul>
					</div>
				</b-collapse>
			</nav>
			<div class="main-content">
				<nav class="navbar navbar-expand-md navbar-light d-none d-md-flex fixed-top" id="topbar">
					<div class="container-fluid justify-content-end">
						<a class="navbar-brand" href="/">
							<img src="../../assets/img/horizontal warna.png" class="navbar-brand-img mx-auto" alt="..." />
						</a>
						<div class="navbar-user">
							<!-- <label
                class="form-check-label"
                for="flexSwitchCheckDefault"
                style="margin-left: -10px"
                >EN</label
              >
              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  id="flexSwitchCheckDefault"
                  @input="changesLang()"
                />
                <label class="form-check-label" for="flexSwitchCheckDefault"
                  >ID</label
                >
              </div> -->
							<div class="dropdown me-4 d-none d-md-flex">
								<!-- Menu -->
								<div class="dropdown-menu dropdown-menu-end dropdown-menu-card">
									<div class="card-header">
										<!-- Title -->
										<h5 class="card-header-title">Notifications</h5>

										<!-- Link -->
										<a href="#!" class="small"> View all </a>
									</div>
									<!-- / .card-header -->
									<div class="card-body">
										<!-- List group -->
										<div class="list-group list-group-flush list-group-activity my-n3">
											<a class="list-group-item text-reset" href="#!">
												<div class="row">
													<div class="col-auto">
														<!-- Avatar -->
														<div class="avatar avatar-sm">
															<img src="../../assets/img/avatars/profiles/avatar-1.jpg" alt="..." class="avatar-img rounded-circle" />
														</div>
													</div>
													<div class="col ms-n2">
														<!-- Content -->
														<div class="small">
															<strong>Dianna Smiley</strong> shared your post with Ab Hadley, Adolfo Hess, and 3 others.
														</div>

														<!-- Time -->
														<small class="text-muted"> 2m ago </small>
													</div>
												</div>
												<!-- / .row -->
											</a>
											<a class="list-group-item text-reset" href="#!">
												<div class="row">
													<div class="col-auto">
														<!-- Avatar -->
														<div class="avatar avatar-sm">
															<img src="../../assets/img/avatars/profiles/avatar-2.jpg" alt="..." class="avatar-img rounded-circle" />
														</div>
													</div>
													<div class="col ms-n2">
														<!-- Content -->
														<div class="small"><strong>Ab Hadley</strong> reacted to your post with a 😍</div>

														<!-- Time -->
														<small class="text-muted"> 2m ago </small>
													</div>
												</div>
												<!-- / .row -->
											</a>
											<a class="list-group-item text-reset" href="#!">
												<div class="row">
													<div class="col-auto">
														<!-- Avatar -->
														<div class="avatar avatar-sm">
															<img src="../../assets/img/avatars/profiles/avatar-3.jpg" alt="..." class="avatar-img rounded-circle" />
														</div>
													</div>
													<div class="col ms-n2">
														<!-- Content -->
														<div class="small">
															<strong>Adolfo Hess</strong> commented
															<blockquote class="mb-0">
																“I don’t think this really makes sense to do without approval from Johnathan since he’s the one...”
															</blockquote>
														</div>

														<!-- Time -->
														<small class="text-muted"> 2m ago </small>
													</div>
												</div>
												<!-- / .row -->
											</a>
											<a class="list-group-item text-reset" href="#!">
												<div class="row">
													<div class="col-auto">
														<!-- Avatar -->
														<div class="avatar avatar-sm">
															<img src="../../assets/img/avatars/profiles/avatar-4.jpg" alt="..." class="avatar-img rounded-circle" />
														</div>
													</div>
													<div class="col ms-n2">
														<!-- Content -->
														<div class="small"><strong>Daniela Dewitt</strong> subscribed to you.</div>

														<!-- Time -->
														<small class="text-muted"> 2m ago </small>
													</div>
												</div>
												<!-- / .row -->
											</a>
											<a class="list-group-item text-reset" href="#!">
												<div class="row">
													<div class="col-auto">
														<!-- Avatar -->
														<div class="avatar avatar-sm">
															<img src="../../assets/img/avatars/profiles/avatar-5.jpg" alt="..." class="avatar-img rounded-circle" />
														</div>
													</div>
													<div class="col ms-n2">
														<!-- Content -->
														<div class="small">
															<strong>Miyah Myles</strong> shared your post with Ryu Duke, Glen Rouse, and 3 others.
														</div>

														<!-- Time -->
														<small class="text-muted"> 2m ago </small>
													</div>
												</div>
												<!-- / .row -->
											</a>
											<a class="list-group-item text-reset" href="#!">
												<div class="row">
													<div class="col-auto">
														<!-- Avatar -->
														<div class="avatar avatar-sm">
															<img src="../../assets/img/avatars/profiles/avatar-6.jpg" alt="..." class="avatar-img rounded-circle" />
														</div>
													</div>
													<div class="col ms-n2">
														<!-- Content -->
														<div class="small"><strong>Ryu Duke</strong> reacted to your post with a 😍</div>

														<!-- Time -->
														<small class="text-muted"> 2m ago </small>
													</div>
												</div>
												<!-- / .row -->
											</a>
											<a class="list-group-item text-reset" href="#!">
												<div class="row">
													<div class="col-auto">
														<!-- Avatar -->
														<div class="avatar avatar-sm">
															<img src="../../assets/img/avatars/profiles/avatar-7.jpg" alt="..." class="avatar-img rounded-circle" />
														</div>
													</div>
													<div class="col ms-n2">
														<!-- Content -->
														<div class="small">
															<strong>Glen Rouse</strong> commented
															<blockquote class="mb-0">
																“I don’t think this really makes sense to do without approval from Johnathan since he’s the one...”
															</blockquote>
														</div>

														<!-- Time -->
														<small class="text-muted"> 2m ago </small>
													</div>
												</div>
												<!-- / .row -->
											</a>
											<a class="list-group-item text-reset" href="#!">
												<div class="row">
													<div class="col-auto">
														<!-- Avatar -->
														<div class="avatar avatar-sm">
															<img src="../../assets/img/avatars/profiles/avatar-8.jpg" alt="..." class="avatar-img rounded-circle" />
														</div>
													</div>
													<div class="col ms-n2">
														<!-- Content -->
														<div class="small"><strong>Grace Gross</strong> subscribed to you.</div>

														<!-- Time -->
														<small class="text-muted"> 2m ago </small>
													</div>
												</div>
												<!-- / .row -->
											</a>
										</div>
									</div>
								</div>
								<!-- / .dropdown-menu -->
							</div>
							<b-nav-item-dropdown right style="list-style-type: none">
								<!-- Using 'button-content' slot -->
								<template #button-content>
									<div>
										<i class="fe fe-user"></i>
										{{ printName() }}
										<i class="fe fe-chevron-down"></i>
									</div>
								</template>
								<b-dropdown-item href="#">
									{{ profile.fullname }}
									<br />
									{{ profile.roles_uenrol ?? 'User' }}
								</b-dropdown-item>
								<hr />
								<router-link tag="b-dropdown-item" to="/profile">Profile</router-link>
								<b-dropdown-item href="#" @click.prevent="logout"> Logout </b-dropdown-item>
							</b-nav-item-dropdown>
						</div>
					</div>
				</nav>
				<router-view style="padding-top: 70px" id="content-view" :class="`${loadData === false ? '' : 'd-none'}`" />
			</div>
		</div>
		<footer class="bg-dark text-center text-lg-start">
			<!-- Copyright -->
			<div class="text-center p-3 text-light" style="background-color: rgba(0, 0, 0, 0.2)">
				Provided by Digitech - GEMS. ©️ 2022 PT. Golden Energy Mines, Tbk.
				<!-- <a class="text-dark" href="https://mdbootstrap.com/">MDBootstrap.com</a> -->
			</div>
			<!-- Copyright -->
		</footer>
	</div>
	<!-- </b-overlay> -->
</template>

<script>
	import { LOGOUT } from '../../api/auth';
	export default {
		name: 'VerticalLayout',
		computed: {
			filteredMenus() {
				// wait for fetched profile and menus
				if (this.menus.length > 0 && this.profile?.roles?.[0]?.menus) {
					return this.filterMenusByAuthorization(this.menus, this.profile.roles[0].menus);
				}
				return [];
			},
		},
		data() {
			return {
				view: false,
				indexTemp: null,
				changeLang: false,
				menus: [],
				navVars: {},
				choice: [1, 2, 3, 4, 5, 6],
				pick: 1,
				expand: true,
				profile: {},
				loadData: true,
			};
		},

		async created() {
			if (this.$workbox) {
				this.$workbox.addEventListener('waiting', () => {
					this.showUpgradeUI = true;
				});
			}
			try {
				await this.getProfile();
				await this.getMenus();
				console.log('initial data fecth success');
			} catch (error) {
				console.error('Error during initial data fetch:', error);
			}
		},
		async mounted() {
			setTimeout(() => {
				this.loadData = false;
			}, 2000);
		},
		methods: {
			load1() {
				this.loadData = true;
				setTimeout(() => {
					this.loadData = false;
				}, 2000);
			},
			changesLang() {
				this.changeLang = !this.changeLang;
				if (this.changeLang == false) {
					this.$i18n.locale = 'en';
				} else {
					this.$i18n.locale = 'id';
				}
			},
			printName() {
				const stringUser = localStorage.getItem('ugems-tokenParsed');
				if (stringUser) {
					const user = JSON.parse(stringUser);
					const given_name = user.given_name;
					return given_name;
				}
				return 'Unknown';
			},

			switchTemplate() {
				this.$refs.baseBody.classList.remove('theme1', 'theme2', 'theme3', 'theme4', 'theme5', 'theme6');
				this.$refs.baseBody.classList.add(`theme${this.pick}`);
				// console.log("switch", this.pick);
			},

			navClick(link) {
				const idx = this.menus.findIndex((e) => e.link === link);
				if (this.menus[idx].childs) {
					let selected = this.menus[idx];

					if (this.$refs[selected.link][0].classList.contains('collapsed')) {
						this.$refs[selected.link][0].classList.remove('collapsed');
					}
				}
			},

			logout() {
				this.$swal({
					title: 'Confirm Logout',
					text: 'Are you sure want to logout?',
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#00D97E',
					cancelButtonColor: '#E63757',
					confirmButtonText: 'Yes!',
				}).then((result) => {
					if (result.isConfirmed) {
						let params = {
							client_id: 'ucontract',
							refresh_token: localStorage.getItem('ugems-refreshToken'),
						};
						LOGOUT(params)
							.then(() => {
								localStorage.clear();
								this.$router.push('/');
								window.location.reload();
							})
							.catch(() => {
								this.$swal('Error', 'Something Went Wrong, Please Try Again', 'error');
							});
					}
				});
			},

			getProfile() {
				console.log('getting profile user');
				this.$store
					.dispatch('profile/getProfile')
					.then(() => {
						this.profile = this.$store.getters['profile/profileData'];
						console.log('profile', this.profile);
						if (this.profile && (this.profile.fullname !== undefined || this.profile.company !== undefined)) {
							localStorage.setItem('company', this.profile.company_id);
							localStorage.setItem('fullname', this.profile.fullname);
							localStorage.setItem('company_name', this.profile.company);
							localStorage.setItem('user_id', this.profile.id);
							localStorage.setItem(
								'role_id',
								this.profile.roleMap ? this.profile?.roleMap?.roles_id : this.profile?.roles[0]?.id
							);
							localStorage.setItem('role_map', JSON.stringify(this.profile.roleMap));
							localStorage.setItem('organizational_unit_name', this.profile.organizational_unit_name);
							localStorage.setItem('divisi', this.profile.divisi);
							localStorage.setItem('department', this.profile.department);
						} else {
							console.warn('Profile data is incomplete or undefined:', this.profile);
						}
					})
					.catch((err) => {
						console.error('Error fetching profile:', err.response?.data?.error || err);
						let params = {
							client_id: 'ucontract',
							refresh_token: localStorage.getItem('ugems-refreshToken'),
						};
						LOGOUT(params)
							.then(() => {
								localStorage.clear();
								window.location.href = '/';
							})
							.catch(() => {
								this.$swal('Error', 'Something Went Wrong, Please Try Again', 'error');
							});
						// throw err;
					});
			},

			getMenus() {
				console.log('getting menu');
				this.$store.dispatch('role/GET_MENUS').then(() => {
					this.menus = this.$store.getters['role/listMenus'];
				});
			},

			filterMenusByAuthorization(allMenus, userMenus) {
				const authorizedMenuIds = new Set();
				for (const userMenu of userMenus) {
					if (userMenu.role_menus && userMenu.role_menus.authorization.includes('read')) {
						authorizedMenuIds.add(userMenu.id);
					}
				}

				const filteredMenus = [];
				for (const allMenu of allMenus) {
					if (authorizedMenuIds.has(allMenu.id)) {
						const filteredParentMenu = {
							...allMenu,
							childs: [],
						}; // Create a copy to modify children
						if (allMenu.childs && allMenu.childs.length > 0) {
							// Filter child menus
							for (const child of allMenu.childs) {
								if (authorizedMenuIds.has(child.id)) {
									filteredParentMenu.childs.push(child);
								}
							}
						}
						filteredMenus.push(filteredParentMenu);
					} else if (allMenu.childs && allMenu.childs.length > 0) {
						const filteredChildren = [];
						for (const child of allMenu.childs) {
							if (authorizedMenuIds.has(child.id)) {
								filteredChildren.push(child);
							}
						}
						if (filteredChildren.length > 0) {
							// If any child has read access, include the parent and its authorized children
							filteredMenus.push({
								...allMenu,
								childs: filteredChildren,
							});
						}
					}
				}

				return filteredMenus;
			},
		},
	};
</script>

<style lang="scss">
	// @import "../../assets/scss/vendors/bootstrap-vue/index";

	@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@500&display=swap');
	/* MY CUSTOM CSS */
	@import url('../../assets/css/mycustom.css');

	.navbar-brand-img {
		max-width: 100% !important;
		max-height: 100% !important;
	}

	#loader {
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 10000;
		background-color: white;
		// background-color: #dfdfde;
		// display: flex !important;
		// justify-content: center !important;
		// align-items: center !important;
	}

	#loader > div {
		position: static !important;
	}

	.vgt-loading__content {
		background-color: #fad7dd !important;
		color: #e63757 !important;
	}
</style>
